import { escapeForJSON } from './placeholderUtils';

export const buildConnectionJSONString = (
  formData: Record<string, unknown>,
  prompt: string
): string => {
  const password = String(formData['externalconnattvalue.PASSWORD'] ?? '');
  const encryptedPassword = btoa(password);

  return JSON.stringify({
    authentications: {
      acctAuth: {
        url: '@CUAURL@',
        authType: 'Basic',
        isCUA: true,
        loginPrompt: escapeForJSON(prompt),
        targetURL: String(formData['externalconnattvalue.URL'] ?? ''),
        targetUsername: String(formData['externalconnattvalue.USERNAME'] ?? ''),
        targetPassword: encryptedPassword,
        properties: {},
      },
    },
  });
};

export const buildConnectionPayload = (
  formData: Record<string, unknown>,
  prompt: string
) => {
  const connectionJSON = buildConnectionJSONString(formData, prompt);

  return {
    multipleconnection: false,
    'externalconnattvalue.ConnectionJSON': connectionJSON,
  };
};

export const buildConnectionJSONTemplate = (
  formData: Record<string, unknown>
): string =>
  `{"authentications":{"acctAuth":{"url":"@CUAURL@","isCUA": true,"authType":"Basic","loginPrompt":"@CUAPROMPT@","targetURL":"${String(
    formData['externalconnattvalue.URL'] || ''
  )}","targetUsername":"${String(
    formData['externalconnattvalue.USERNAME'] || ''
  )}","targetPassword":"${btoa(
    String(formData['externalconnattvalue.PASSWORD'] || '')
  )}","properties":{}}}}`;
